(function() {
  angular
  .module('meanApp')
  .factory('departmentsManager', departmentsManager);

  departmentsManager.$inject = ["Department", "modelManager"];
  function departmentsManager (Department, modelManager) {
		return angular.extend({}, modelManager.init(Department));
  };

})();